export const isValidHttpUrl = (
  string: string,
  isProtocolRequired?: boolean
) => {
  if (!/^.*[^.]+\.[^.]+.*$/i.test(string) && !string.includes("localhost")) {
    return false;
  }

  let url;
  let urlString = string;

  try {
    // If no protocol is provided, prepend https://
    if (!isProtocolRequired && !/^https?:\/\//i.test(urlString)) {
      urlString = `https://${urlString}`;
    }
    url = new URL(urlString);
  } catch {
    return false;
  }

  if (url.protocol !== "http:" && url.protocol !== "https:") {
    return false;
  }

  // Ensure hostname is localhost or has a valid domain structure
  const { hostname } = url;
  const isLocalhost = hostname === "localhost";
  const parts = hostname.split(".");
  const tld = parts[parts.length - 1];
  const hasValidDomain =
    parts.length >= 2 &&
    tld.length >= 2 &&
    parts.every((part) => part.length > 0);

  return isLocalhost || hasValidDomain;
};
